import * as atatus from 'atatus-spa';

const isEnabled = !!process.env.REACT_APP_ATATUS_API_KEY;
const isProduction = process.env.REACT_APP_SSO_KEY === 'prod';

export const initAtatus = () => {
  if (isEnabled) {
    atatus.config(process.env.REACT_APP_ATATUS_API_KEY!, {
      tags: [ process.env.REACT_APP_SSO_KEY || 'local' ],
      console: !isProduction,
      reportUnhandledRejections: true,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
      ],
    }).install();
  }
};

export const notifyAtatus = (error: Error, customData?: Record<string, unknown>) => {
  if (isEnabled) {
    atatus.notify(error, customData ? { customData } : undefined);
  }
};

export const setAtatusUser = (identifier: string) => {
  if (isEnabled) {
    atatus.setUser(identifier);
  }
};
